import { createSlice } from "@reduxjs/toolkit";

export const nlpSlice = createSlice({
  name: "nlp",
  initialState: {},
  reducers: {},
});

export const { actions: nlpActions, reducer: nlpReducer } = nlpSlice;
